var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtwNotstarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 38,
    viewBox: "0 0 46 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008662"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250842",
    d: "M1 37.002H45",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 234250843"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 18.9951V29.9951H40H30H25V17.4951V9.49512H38C38 9.49512 38.5116 13.5241 40 15.4951C41.4364 17.3972 45 18.9951 45 18.9951Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 17.4951V9.49512H38C38 9.49512 38.5116 13.5241 40 15.4951C41.4364 17.3972 45 18.9951 45 18.9951V29.9951H40H30H25V17.4951ZM25 17.4951H34.5",
    stroke: "#383434",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250846",
    d: "M1 29.999H9M25 9.49902H38C38 9.49902 38.5116 13.528 40 15.499C41.4364 17.4011 45 18.999 45 18.999V29.999H40M25 9.49902V0.999023H10.5M25 9.49902V17.499M25 29.999V17.499M25 29.999H19M25 29.999H30M25 17.499H34.5",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250844",
    d: "M5.5 9.49512H17.5",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250845",
    d: "M2 17.5029H14",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1023",
    cx: 14,
    cy: 31.498,
    r: 5,
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1024",
    cx: 35.002,
    cy: 31.498,
    r: 5,
    fill: "white",
    stroke: "#383434",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtwNotstarted);
export default __webpack_public_path__ + "static/media/OTW_notstarted.93930174a69770215cc9cdc2d6cfc34b.svg";
export { ForwardRef as ReactComponent };